module.exports = __webpack_public_path__ + "static/media/objects_15.24644cda.svg";